/**
 * Auth API Client — nexus-auth profile operations.
 *
 * v4: the opinionated `nexusClient` from the SDK owns all auth plumbing
 * (Authorization bearer, CSRF token on state-changing verbs, cookie
 * credentials). It points at `config.apiUrl` — the nexus-auth service —
 * so every request made through it lands on the auth backend, which is
 * the source of truth for user profile data.
 *
 * This module re-exports `nexusClient` as `authApiClient` so existing
 * imports keep working, and provides a typed `authProfileApi` wrapper
 * for profile read/update.
 *
 * There are NO more localStorage reads, NO X-User-Id / X-Device-Id
 * injection, and NO manual refresh plumbing — all of that is the SDK's
 * responsibility now.
 */
import { nexusClient } from '@azyntor-labs/nexus-auth';

export const authApiClient = nexusClient;

export interface UpdateProfileRequest {
  first_name?: string;
  last_name?: string;
  avatar_url?: string;
  phone?: string;
  username?: string;
}

export const authProfileApi = {
  getProfile: () => nexusClient.get('/api/v1/user/profile'),
  updateProfile: (data: UpdateProfileRequest) =>
    nexusClient.put('/api/v1/user/profile', data),
};

export default nexusClient;
